import { ReactNode, useMemo } from "react";
import { useLocation, useParams } from "react-router-dom";
import {
  getRouteCreateProject,
  getRouteNewVersion,
  getRouteProjectDetails,
  getRouteReviewRelaunch
} from "@/zapi-frontend/shared/const/router";
import { AppHeader } from "./_AppHeader";
import { ProjectDetailsHeader } from "./_ProjectDetailsHeader";
import { CreateProjectHeader } from "./_CreateProjectHeader";

type THeaderProps = { slot?: ReactNode };

export function Header({ slot }: THeaderProps) {
  const { pathname } = useLocation();
  const { id, projectId } = useParams();

  const headerContent = useMemo(() => {
    if (id && pathname === getRouteProjectDetails(id)) return <ProjectDetailsHeader />;
    if (projectId && (pathname === getRouteNewVersion(projectId) || pathname === getRouteReviewRelaunch(projectId)))
      return <ProjectDetailsHeader />;
    if (pathname === getRouteCreateProject()) return <CreateProjectHeader />;

    return <AppHeader />;
  }, [pathname, id, projectId]);

  return (
    <div
      data-testid="header-container"
      className="bg-white h-14 shrink-0 relative flex justify-between items-center gap-4 pl-[16px] pr-3"
    >
      {headerContent}
      <div className="flex items-center gap-2 w-fit">{slot}</div>
    </div>
  );
}
